import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AgrFilterModule, AgrNotificationEmptyModule, AgrPageToolbarModule } from '@next/core-lib/components';

import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { TableV2Module } from '@next/core-lib/table-v2';

import { ConfirmOrderDialogOverviewV2Component } from './components/confirm-order-dialog/confirm-order-dialog.component';
import { DigitalProductsDialogComponent } from './components/digital-products-dialog/digital-products-dialog.component';
import { MoveProductsDialogComponent } from './components/move-products-dialog/move-products-dialog.component';
import { OrderPlanningTableComponent } from './components/order-planning-table/order-planning-table.component';
import { PeriodColumnComponent } from './components/period-column/period-column.component';
import { PeriodColumnHeaderComponent } from './components/period-column-header/period-column-header.component';
import { OverviewV2Component } from './overview-v2.component';
import { SwitchTranslationPipe } from './pipes/switch-translation.pipe';
import { SharedModule } from '../shared/shared.module';
import { BemProductsComponent } from './components/digital-products-dialog/bem-products/bem-products.component';

@NgModule({
  declarations: [
    SwitchTranslationPipe,
    OverviewV2Component,
    MoveProductsDialogComponent,
    SwitchTranslationPipe,
    PeriodColumnComponent,
    PeriodColumnHeaderComponent,
    OrderPlanningTableComponent,
    ConfirmOrderDialogOverviewV2Component,
    DigitalProductsDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AgrDialogModule,
    AgrFormModule,
    AgrPageToolbarModule,
    AgrFilterModule,
    AgrNotificationEmptyModule,
    TableV2Module,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatDividerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatListModule,
    MatExpansionModule,
    MatTableModule,
    MatTooltipModule,
    MatButtonModule,
    BemProductsComponent,
  ],
})
export class OverviewV2Module {}
